import { verifyInterface } from "../../../utils";
import * as Turbo from "@hotwired/turbo";
import { terminalRequest } from "../utils";

export class Config {
  requiredInterface = ["toggleLockedUrlValue", "calibProcessTarget"];

  constructor(controllerCtxt) {
    verifyInterface(controllerCtxt, {
      requiredInterface: this.requiredInterface,
    });
    controllerCtxt.send({ action: "requestCalibProcess" });
    this.ctrl = controllerCtxt;
  }

  handleEvent(event) {
    switch (event.action) {
      case "employeeDetected":
        this.toggleLocked(event.id);
        break;
      case "calibProcess":
        this.setCalibProcess(event);
        break;
      default:
        console.error("unsupported event for mode 'Scan'", event);
    }
  }
  setCalibProcess(event) {
    delete event.action;
    this.ctrl.calibProcessTarget.innerText = JSON.stringify(event);
  }

  async toggleLocked(employeeId) {
    const formData = new FormData();
    formData.append("employee_id", employeeId);
    const turboResponse = await terminalRequest(
      this.ctrl.toggleLockedUrlValue,
      { formData },
    );
    if (!turboResponse.is_stream) {
      console.log(turboResponse);
      throw new Error("DEVELOPMENT ERROR - expected stream.");
    }
    Turbo.renderStreamMessage(turboResponse.html);
  }
}
